import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {Card, CardContent, CardActions, CardMedia, CardHeader } from '@material-ui/core';
import { Button, Typography, Divider } from '@material-ui/core';
import { Loader } from '../Loading';
import { FormattedMessage } from 'react-intl';
import { withNavigation } from '../../actions/navigation';

/**
 * Product view
 * Displays the product name and description, 
 * along with a "learn more" link to the product URL
 */

const NEWLINE = "\n";

const styles = theme => ({
  card: {
    borderRadius: 12,
  },
  logo: {
    height: 56,
    width: 56,
    marginTop: 24,
    marginRight: 'auto',
    marginLeft: 'auto',
    backgroundSize: 'contain', 
  },
  header: {
    marginTop: 8,
  },
  content: {
    paddingTop: 0,
    marginTop: 8,
    minHeight: 144,
  },
  actions: {
    display:'flex', 
    flexDirection:'column', 
    justifyContent:'space-between', 
    marginTop: 8,
  },
  textBody: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontWeight: 400,
    fontSize: 16,
  },
  textTitle: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 400,
    fontSize: 22,
  },
  button: {
    marginBottom: 10,
  }
});

const ProductCard = ({ classes, product, navigateToProduct, navigateToSubscription, subscription }) => (
  product
    ? <Card className={classes.card} >
      {product.iconUrl &&
        <CardMedia className={classes.logo} image={product.iconUrl} />
      }
      <CardHeader
        className={classes.header}
        title={
          <Typography align="center" className={classes.textTitle} >{product.name}</Typography>
        }
      />
      <CardContent className={classes.content}>
        {
          product.description && product.description
            .split(NEWLINE)
            .map((line, i) =>
              <Typography component="p" key={i} align="center" className={classes.textBody}>{line}</Typography>
            )
        }
      </CardContent>
      <Divider/>
      <CardActions className={classes.actions}>
        {
          subscription 
          ? <Button
              color="primary"
              size="medium"
              onClick={() => navigateToSubscription(subscription.id)}
              target="_blank">
                <FormattedMessage id='subscription.button.manageSubscription' /> 
            </Button> 
          : <Button
              color="primary"
              size="medium"
              onClick={() => navigateToProduct(product)}
              target="_blank">
                <FormattedMessage id='subscription.button.getStarted' /> 
            </Button> 
        }
        { product.url && 
          <Button
            className={classes.button}
            color="primary"
            size="medium"
            href={product.learnMoreUrl}
            target="_blank">
              <FormattedMessage id='product.button.learnMore' />
          </Button>
        }
      </CardActions>
    </Card>
    : <Loader />
);

ProductCard.propTypes = {
  product: PropTypes.object,
  navigateToProduct: PropTypes.func.isRequired,
  enableManageButton: PropTypes.bool,
}

export default withStyles(styles)(
  withNavigation(ProductCard)
);


// WEBPACK FOOTER //
// ./src/components/products/ProductCard.js